module.exports = __webpack_public_path__ + "img/76.9e32921d.jpg";